/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Abilities_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "No. Before doing anything outside oneAI, like sending a message or changing data in a connected tool, it asks you first." |
*
* @param {Uno_Edu_Agent_Abilities_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_abilities_chip2_answer = /** @type {((inputs?: Uno_Edu_Agent_Abilities_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Abilities_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nein. Bevor er etwas außerhalb von oneAI tut, etwa eine Nachricht verschickt oder Daten in einem verbundenen Werkzeug ändert, fragt er Sie.")
	return /** @type {LocalizedString} */ ("No. Before doing anything outside oneAI, like sending a message or changing data in a connected tool, it asks you first.")
});